// extracted by mini-css-extract-plugin
export default {"invalidContentFragmentWarning":"UAfDw5v"};